<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_4"></a>Text copyright © 2013 by Domenica Marchetti.</p>
<p class="copyright">Photographs copyright © 2013 by Sang An.</p>
<p class="copyright">All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p class="copyright">ISBN 978-1-4521-2964-8</p>
<p class="copyright">The Library of Congress has cataloged the print edition under ISBN 978-1-4521-0886-5.</p>
<p class="copyright">Designed by Sara Schneider<br/>Prop styling by Glenn Jenkins<br/>Food styling by George Dolese<br/>Assistant food styling by Elizabet Nederlanden<br/>Typesetting by DC Type</p>
<p class="copyright">Cynar is a registered trademark of Campari. Rogue Creamery<br/>Smokey Blue is a registered trademark of Rogue Creamery.</p>
<p class="copyright"> </p>
<p class="copyright">Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107<br/><span class="weblink"><a href="http://www.chroniclebooks.com" target="_blank">www.chroniclebooks.com</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02copyright.vue?45c70548